import { render, staticRenderFns } from "./pegasusonlineaktarim.vue?vue&type=template&id=65700933&scoped=true&"
import script from "./pegasusonlineaktarim.vue?vue&type=script&lang=js&"
export * from "./pegasusonlineaktarim.vue?vue&type=script&lang=js&"
import style0 from "./pegasusonlineaktarim.vue?vue&type=style&index=0&id=65700933&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65700933",
  null
  
)

export default component.exports